import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/user-info-fill.svg'


const _hoisted_1 = { class: "flex justify-between items-center pb-3 mb-8 border-b-2 border-brand-400" }
const _hoisted_2 = { class: "flex justify-start items-center space-x-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-16 rounded-md bg-gray-300 animate-pulse" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 my-11 rounded-full bg-gray-300 animate-pulse w-1/2" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "flex justify-start items-center space-x-4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "w-16 h-16 flex justify-center items-center rounded-md bg-gray-300 mb-4 lg:mb-8"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "video icon"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "grid grid-cols-3 gap-4 lg:gap-6" }
const _hoisted_12 = {
  key: 0,
  class: "col-span-3 lg:col-span-1"
}
const _hoisted_13 = {
  key: 1,
  class: "col-span-3 lg:col-span-1"
}
const _hoisted_14 = { class: "col-span-3 lg:col-span-3" }
const _hoisted_15 = {
  key: 2,
  class: "col-span-3 lg:col-span-3"
}

import {  // api
		getContactByRecordId
	} from './queries'

	import { 
		Auth
	} from '@/api/Auth'

		// components
	import AccountDetails from './components/AccountDetails.vue'
	import BankInformation from './components/BankInformation.vue'
	import ContactInformation from './components/ContactInformation.vue'
	import PersonalInformation from './components/PersonalInformation.vue'
	import AreaDetails from './components/AreaDetails.vue'
	import UnavailabilityDetails from './components/UnavailabilityDetails.vue'

		// events
	import EventBus from '@/events'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // router
		useRouter
	} from 'vue-router'

	import { // store
		store as _userStore
	} from '@/store/user'

	import { 
		localesStore as _localesStore
	} from '@/store/locales'

	import { // types
		FileMakerRecord
	} from '@/types'

	import { // vue
		inject,
		onBeforeUnmount,
		onMounted,
		ref
	} from 'vue'

	
	const __default__ = { name: 'AccountMain' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const loading = ref(false)

	const userStore = _userStore()
	const localesStore = _localesStore()

	const router = useRouter()

	const {t} = useI18n()

	const breadcrumb = ref([
		{label: 'Account', to: {name: 'Account'}}
	])

	const contact = ref<FileMakerRecord>({} as FileMakerRecord)

	const s3: any = inject('s3')
	const signedUrl = ref('')

	onMounted(async () => {
		loading.value = true
		await getData(false)

		EventBus.on('change-language', async () => {
			await getData(true)
		})

		// load image from s3
		try {
			const s3Json = JSON.parse(contact.value?.fieldData?.['contact__CONTACTS_INFO__contactID::s3JSONPicture'] || "{}")
			const key = s3Json?.thumbnail?.s3FilePathShortRaw

			let params = {
				Bucket: process.env.VUE_APP_S3_BUCKET,
				Key: key
			}

			s3.getSignedUrlPromise('getObject', params).then(
				function (url: string) {
					signedUrl.value = url
				}, 
				function (err: Error) { 
					throw err
				}
			)
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	})

	onBeforeUnmount(() => {
		EventBus.off('change-language', null)
	})	

	async function getData(showLoading: boolean) {
		try {
			loading.value = true
			const scriptParams = JSON.stringify({
				language: localesStore.getFmLanguage
			})

			const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
			const recordId = userStore.user.recordId

			// fetch job by record id
			let res = await getContactByRecordId(recordId, params)
			const record = res.response.data[0]
			contact.value = record
		}
		catch(e: any) {
			console.log(e)

			// redirect if server session expired 
			if(e?.code == "952") {
				await Auth.signOut()
				router.push({name: "Login"})
			}
		}
		finally {
			loading.value = false && !showLoading
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_breadcrumb = _resolveComponent("tw-breadcrumb")!
  const _component_collapsable_card = _resolveComponent("collapsable-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_tw_breadcrumb, { crumbs: breadcrumb.value }, null, 8, ["crumbs"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_5, 512), [
      [_vShow, loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      (signedUrl.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "w-16 h-16 flex rounded-md object-cover mb-4 lg:mb-8",
            src: signedUrl.value
          }, null, 8, _hoisted_7))
        : (!signedUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("h1", { class: "page-title" }, _toDisplayString(contact.value?.fieldData?.name_full_company_display), 513), [
        [_vShow, !loading.value]
      ])
    ], 512), [
      [_vShow, !loading.value]
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: _normalizeClass([_unref(userStore).getContactType === 'Staff' ? 'lg:col-span-2' : 'lg:col-span-3', 'col-span-3 lg:col-span-2'])
      }, [
        _createVNode(_component_collapsable_card, {
          title: _unref(t)('account.accountDetails'),
          fixed: ""
        }, {
          default: _withCtx(() => [
            _createVNode(AccountDetails, {
              contact: contact.value,
              loading: loading.value
            }, null, 8, ["contact", "loading"])
          ]),
          _: 1
        }, 8, ["title"])
      ], 2),
      (_unref(userStore).getContactType == 'Staff')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_collapsable_card, {
              title: _unref(localesStore).getLabel('384'),
              fixed: ""
            }, {
              default: _withCtx(() => [
                _createVNode(PersonalInformation, {
                  contact: contact.value,
                  loading: loading.value
                }, null, 8, ["contact", "loading"])
              ]),
              _: 1
            }, 8, ["title"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([_unref(userStore).getContactType === 'Staff' ? 'lg:col-span-2' : 'lg:col-span-3', 'col-span-3 lg:col-span-2'])
      }, [
        _createVNode(_component_collapsable_card, {
          title: _unref(t)('account.contactInformation'),
          fixed: ""
        }, {
          default: _withCtx(() => [
            _createVNode(ContactInformation, {
              contact: contact.value,
              loading: loading.value,
              "contact-type": _unref(userStore).getContactType
            }, null, 8, ["contact", "loading", "contact-type"])
          ]),
          _: 1
        }, 8, ["title"])
      ], 2),
      (_unref(userStore).getContactType === 'Staff')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_collapsable_card, {
              title: _unref(localesStore).getLabel('452'),
              fixed: ""
            }, {
              default: _withCtx(() => [
                _createVNode(AreaDetails, {
                  contact: contact.value,
                  loading: loading.value
                }, null, 8, ["contact", "loading"])
              ]),
              _: 1
            }, 8, ["title"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_collapsable_card, {
          title: _unref(localesStore).getLabel('76')
        }, {
          default: _withCtx(() => [
            _createVNode(BankInformation, {
              contact: contact.value,
              loading: loading.value,
              "contact-type": _unref(userStore).getContactType
            }, null, 8, ["contact", "loading", "contact-type"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      (_unref(userStore).getContactType === 'Staff')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_collapsable_card, {
              class: "relative",
              title: _unref(t)('account.upcomingUnavailability')
            }, {
              default: _withCtx(() => [
                _createVNode(UnavailabilityDetails, {
                  class: "relative",
                  contact: contact.value,
                  loading: loading.value,
                  onRefreshAccountData: _cache[0] || (_cache[0] = async () => { await getData(false) })
                }, null, 8, ["contact", "loading"])
              ]),
              _: 1
            }, 8, ["title"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})